import React, { Component } from 'react';

class Add extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 74 74">
                <style type="text/css">
                    {".st0{fill:none;stroke:#9c9c9c;stroke-width:3;stroke-miterlimit:10;}.st1{fill:#9c9c9c;}"}
                </style>
                <path className="st0" d="M62.5,4.3h-49c-4.4,0-8,3.6-8,8v30c0,4.4,3.6,8,8,8h22.1c-2.5-6,0.4-14.5,8.9-14.5c8.5,0,11.4,8.6,8.9,14.5h9.1
                    c4.4,0,8-3.6,8-8v-30C70.5,7.9,66.9,4.3,62.5,4.3z"/>
                <circle className="st0" cx="44.4" cy="45.8" r="10.1"/>
                <path className="st1" d="M35.4,53.7L31.9,66c-0.4,1.6,2.4,2.4,2.9,0.8l3.4-12.3C38.7,52.9,35.8,52.1,35.4,53.7z"/>
                <path className="st1" d="M42.4,55.9l-3.4,12.3c-0.4,1.6,2.4,2.4,2.9,0.8l3.4-12.3C45.7,55.1,42.8,54.3,42.4,55.9z"/>
                <path className="st1" d="M36.4,65.2l2.4,4.1c0.9,1.5,3.5-0.1,2.6-1.5L39,63.7C38.1,62.2,35.5,63.7,36.4,65.2z"/>
                <path className="st1" d="M36.7,63.5l-4.3,2.4c-1.6,0.8-0.1,3.5,1.4,2.6l4.3-2.4C39.7,65.3,38.3,62.6,36.7,63.5z"/>
                <path className="st1" d="M52.7,53.7l3.7,12.2c0.5,1.6-2.4,2.5-2.9,0.9l-3.7-12.2C49.4,52.9,52.2,52,52.7,53.7z"/>
                <path className="st1" d="M45.8,56l3.7,12.2c0.5,1.6-2.4,2.5-2.9,0.9l-3.7-12.2C42.4,55.3,45.3,54.4,45.8,56z"/>
                <path className="st1" d="M51.9,65.2l-2.3,4.2c-0.8,1.5-3.5,0-2.6-1.5l2.3-4.2C50.2,62.2,52.8,63.7,51.9,65.2z"/>
                <path className="st1" d="M51.6,63.5l4.4,2.3c1.6,0.8,0.2,3.5-1.4,2.7l-4.4-2.3C48.6,65.3,50,62.7,51.6,63.5z"/>
                <path className="st1" d="M59.9,14.4H16.3c-1.9,0-1.9,3,0,3h43.6C61.8,17.4,61.8,14.4,59.9,14.4z"/>
                <path className="st1" d="M60.3,25.8h-44c-1.9,0-1.9,3,0,3h44C62.2,28.8,62.2,25.8,60.3,25.8z"/>
                <path className="st1" d="M36.4,37.4h-20c-1.9,0-1.9,3,0,3h20C38.3,40.4,38.3,37.4,36.4,37.4z"/>
                <path className="st1" d="M60,37.3h-6.9c-1.9,0-1.9,3,0,3H60C61.9,40.3,61.9,37.3,60,37.3z"/>
            </svg>
        );
    }
}

export default Add;



// WEBPACK FOOTER //
// ./src/icons/Certify.js